import { makeAutoObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';

export default class BrokerMessagePageStore {
  private _isLoading = false;
  private _initiateAnswers: Record<string, string> = {};
  private _enrollmentPeriodModule = new EnrollmentPeriodModule();

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get initiateAnswers(): Record<string, string> {
    return this._initiateAnswers;
  }

  private setIsLoading(status: boolean): void {
    this._isLoading = status;
  }

  public async getInitialData(periodId: string, cartId: string): Promise<void> {
    this.setIsLoading(true);
    await this._enrollmentPeriodModule.uploadEnrollmentPeriod(periodId);

    runInAction(() => {
      const proposal = this._enrollmentPeriodModule.getProposalById(cartId);
      const responseDueDate = proposal.initiateFormAnswers?.responseDueDate;

      this._initiateAnswers = {
        'Proposal Name:': proposal.name,
        'Response Due Date:': responseDueDate ? normDateToShortAmericanDate(responseDueDate) : '',
      };
      this.setIsLoading(false);
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}

const PageStoreContext = createContext(new BrokerMessagePageStore());

export const useBrokerMessagePageStore = (): BrokerMessagePageStore => {
  return useContext(PageStoreContext);
};

export { PageStoreContext };
